/**
 * Firebase web config (public, not secret — it identifies the project, it doesn't authorize). Read
 * from VITE_FIREBASE_* env at build time. Returns null when unset so the app falls back to
 * local-only mode. See the setup checklist for where these values come from (Firebase console →
 * Project settings → Your apps → SDK setup and configuration).
 */
export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  /** Optional; only needed for some Firebase products (analytics/storage). */
  storageBucket?: string;
  messagingSenderId?: string;
  /** Web-push VAPID public key (Firebase console → Cloud Messaging → Web Push certificates). Enables
   *  web FCM so an open web tab is woken for new Daily Signals (SIG-08); absent → focus-refetch only. */
  vapidKey?: string;
}

export function readFirebaseConfig(): FirebaseWebConfig | null {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  const appId = import.meta.env.VITE_FIREBASE_APP_ID;
  if (!apiKey || !authDomain || !projectId || !appId) return null;
  return {
    apiKey,
    authDomain,
    projectId,
    appId,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
  };
}
